import { render, staticRenderFns } from "./attachmentPreview.vue?vue&type=template&id=39051d0c&scoped=true"
import script from "./attachmentPreview.vue?vue&type=script&lang=js"
export * from "./attachmentPreview.vue?vue&type=script&lang=js"
import style0 from "./attachmentPreview.vue?vue&type=style&index=0&id=39051d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39051d0c",
  null
  
)

export default component.exports